(function () {
  'use strict';

  document.querySelectorAll('[data-section-type="product"]').forEach(function (root) {
    var sectionId = root.getAttribute('data-section-id');
    var jsonEl = document.getElementById('ProductJson-' + sectionId);
    var savePercentEl = root.querySelector('[data-save-percent-text]');
    var saveBadgeEl = root.querySelector('[data-save-badge]');
    var urgencyEl = root.querySelector('[data-urgency]');
    if (!jsonEl || !savePercentEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var optionInputs = Array.prototype.slice.call(
      root.querySelectorAll('input[type="radio"][data-index]')
    );
    if (!optionInputs.length) return;

    function currentOptionValues() {
      var values = [];
      optionInputs.forEach(function (input) {
        if (!input.checked) return;
        var position = parseInt(input.getAttribute('data-index').replace('option', ''), 10) - 1;
        values[position] = input.value;
      });
      return values;
    }

    function findVariant(values) {
      return product.variants.find(function (variant) {
        return values.every(function (val, i) {
          return val == null || variant.options[i] === val;
        });
      });
    }

    function updateBadge(variant) {
      if (!variant) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var percent = onSale
        ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
        : 0;

      savePercentEl.textContent = percent;
      if (saveBadgeEl) saveBadgeEl.classList.toggle('hide', !onSale);
      if (urgencyEl) urgencyEl.classList.toggle('hide', !onSale);
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateBadge(findVariant(currentOptionValues()));
      });
    });
  });
})();
